import { useRef, useState } from "react";
import axios from "axios";
import { X, Upload, Trash2 } from "lucide-react";
import { Seal } from "./Seal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function SealRow({ inst, onUploaded }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const r = await axios.post(`${API}/institutions/${inst.rank}/seal`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onUploaded(inst.rank, r.data.seal_image);
    } catch (e) {
      console.error("seal upload failed", e);
    } finally {
      setBusy(false);
    }
  };

  const clear = async () => {
    setBusy(true);
    try {
      await axios.delete(`${API}/institutions/${inst.rank}/seal`);
      onUploaded(inst.rank, null);
    } catch (e) {
      console.error("seal clear failed", e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="seal-row" data-testid={`seal-row-${inst.rank}`}>
      <Seal inst={inst} size={38} testid={`seal-manager-preview-${inst.rank}`} />
      <span className="seal-row-name">
        <span className="seal-row-rank">#{inst.rank}</span>
        {inst.name}
      </span>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        data-testid={`seal-input-${inst.rank}`}
        onChange={(e) => upload(e.target.files?.[0])}
      />
      <button
        className="seal-upload-btn"
        data-testid={`seal-upload-${inst.rank}`}
        disabled={busy}
        onClick={() => inputRef.current?.click()}
      >
        <Upload size={13} strokeWidth={2} />
        {inst.seal_image ? "Replace" : "Upload"}
      </button>
      {inst.seal_image && (
        <button
          className="seal-clear-btn"
          data-testid={`seal-clear-${inst.rank}`}
          disabled={busy}
          onClick={clear}
        >
          <Trash2 size={13} strokeWidth={2} />
        </button>
      )}
    </div>
  );
}

export function SealManager({ open, institutions, onUploaded, onClose }) {
  if (!open) return null;
  return (
    <div className="seal-modal-backdrop" data-testid="seal-manager" onClick={onClose}>
      <div className="seal-modal" onClick={(e) => e.stopPropagation()}>
        <div className="seal-modal-head">
          <div>
            <span className="hud-eyebrow">Brand Assets</span>
            <h2 className="seal-modal-title">University Seals</h2>
            <p className="seal-modal-note">
              Upload an official seal image for any institution. It replaces the
              generated crest on its node and dashboard.
            </p>
          </div>
          <button className="seal-modal-close" data-testid="seal-manager-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        <div className="seal-modal-list">
          {institutions.map((inst) => (
            <SealRow key={inst.rank} inst={inst} onUploaded={onUploaded} />
          ))}
        </div>
      </div>
    </div>
  );
}
